import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CURRENCIES } from '../constants';

const CALC_ROUTES = [
  { path: '/rent',           label: 'Can I Afford This Apartment?' },
  { path: '/credit-card',    label: 'Credit Card Payoff' },
  { path: '/mortgage',       label: 'How Much House Can I Afford?' },
  { path: '/retirement',     label: 'Am I Saving Enough for Retirement?' },
  { path: '/debt-invest',    label: 'Pay Off Debt or Invest?' },
  { path: '/raise',          label: "What's My Raise Actually Worth?" },
  { path: '/millionaire',    label: "How Long Until I'm a Millionaire?" },
  { path: '/savings-growth', label: 'Savings Growth Calculator' },
  { path: '/currency',       label: 'Currency Converter' },
];

export default function Navbar({ currency, onCurrencyChange }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const close = () => setMenuOpen(false);

  return (
    <>
      <nav>
        <div className="nav-inner">
          <Link to="/" className="logo" onClick={close}>Finance<span>Calculator</span></Link>

          {/* Desktop links */}
          <ul className="nav-links desktop-nav">
            <li><Link to="/">Home</Link></li>
            <li className="nav-dropdown">
              <button>Calculators ▾</button>
              <div className="dropdown-menu">
                {CALC_ROUTES.filter(r => r.path !== '/currency').map(r => (
                  <Link key={r.path} to={r.path} className="dropdown-item">{r.label}</Link>
                ))}
              </div>
            </li>
            <li><Link to="/currency">Currency Converter</Link></li>
            <li>
              <select className="currency-picker" value={currency} onChange={e => onCurrencyChange(e.target.value)}>
                {CURRENCIES.map(c => (
                  <option key={c.code} value={c.code}>{c.flag} {c.code}</option>
                ))}
              </select>
            </li>
          </ul>

          {/* Mobile right side */}
          <div className="mobile-nav-right">
            <select className="currency-picker" value={currency} onChange={e => onCurrencyChange(e.target.value)}>
              {CURRENCIES.map(c => (
                <option key={c.code} value={c.code}>{c.flag} {c.code}</option>
              ))}
            </select>
            <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
              {menuOpen ? (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              ) : (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
                </svg>
              )}
            </button>
          </div>
        </div>
      </nav>

      {menuOpen && (
        <div className="mobile-menu-overlay" onClick={close}>
          <div className="mobile-menu" onClick={e => e.stopPropagation()}>
            <div className="mobile-menu-header">
              <span className="logo">Finance<span>Calculator</span></span>
              <button className="hamburger" onClick={close}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
            <div className="mobile-menu-section-title">Calculators</div>
            {CALC_ROUTES.map(r => (
              <Link
                key={r.path}
                to={r.path}
                className={'mobile-menu-item' + (location.pathname === r.path ? ' active' : '')}
                onClick={close}
              >
                {r.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
